// extracted by mini-css-extract-plugin
export default {"contactsInfoWrapper":"ContactInformation_contactsInfoWrapper__hHvxO","contactsInfoItemWrapper":"ContactInformation_contactsInfoItemWrapper__oXN9i"};